<div class="hd">

  <header class="hd-head">
    <div>
      <h1>🎨 {{ tr('হোমপেজ ডিজাইন', 'Homepage Design') }}</h1>
      <p>
        {{ tr(
          'হোমপেজের সব কিছু এক জায়গা থেকে ঠিক করুন — সেকশনের ক্রম, প্রতিটা সেকশনের পরের ব্যানার, পপুলার ক্যাটাগরি, ব্র্যান্ড।',
          'Control everything on the homepage from one place — section order, banners after each section, popular categories and brands.'
        ) }}
      </p>
    </div>
  </header>

  <nav class="hd-tabs">
    <button type="button" [class.on]="tab === 'layout'" (click)="setTab('layout')">
      🧩 {{ tr('সেকশন ও ব্যানার', 'Sections & banners') }}
    </button>
    <button type="button" [class.on]="tab === 'categories'" (click)="setTab('categories')">
      🔥 {{ tr('পপুলার ক্যাটাগরি', 'Popular categories') }}
    </button>
    <button type="button" [class.on]="tab === 'brands'" (click)="setTab('brands')">
      🏷️ {{ tr('পপুলার ব্র্যান্ড', 'Popular brands') }}
    </button>
    <button type="button" [class.on]="tab === 'features'" (click)="setTab('features')">
      ✨ {{ tr('ফিচার বার', 'Features bar') }}
    </button>
    <button type="button" [class.on]="tab === 'shopmore'" (click)="setTab('shopmore')">
      🛍️ {{ tr('শপ মোর', 'Shop more') }}
    </button>
  </nav>

  <div class="toast" *ngIf="notice" [class.err]="noticeError">{{ notice }}</div>


  <!-- =====================================================
       ১) সেকশন ও ব্যানার
  ====================================================== -->
  <section *ngIf="tab === 'layout'">

    <div class="bar">
      <p class="hint">
        {{ tr(
          'উপর-নিচ তীর দিয়ে সেকশন সাজান, চোখ দিয়ে দেখানো/লুকানো ঠিক করুন। প্রতিটা সেকশনের ঠিক নিচে ব্যানার দেওয়ার জায়গা আছে — ব্যানার না দিলে সেখানে কিছুই দেখাবে না (ফাঁকা থাকবে)।',
          'Use the arrows to reorder and the eye to show/hide. Each section has a banner area right below it — if you add no banner, nothing is shown there.'
        ) }}
      </p>

      <div class="bar-actions">
        <button type="button" class="btn ghost" (click)="resetLayout()">
          ↺ {{ tr('ডিফল্টে ফেরান', 'Reset') }}
        </button>
        <button type="button" class="btn primary" [disabled]="saving || !dirty" (click)="saveLayout()">
          {{ saving ? tr('সেভ হচ্ছে...', 'Saving...') : '💾 ' + tr('ক্রম ও সেটিং সেভ করুন', 'Save order & settings') }}
        </button>
      </div>
    </div>

    <div class="loading" *ngIf="loadingSections">{{ tr('সার্ভার থেকে সেটিং আনা হচ্ছে... (সার্ভার ঘুমিয়ে থাকলে ১০ সেকেন্ড লাগতে পারে)', 'Fetching settings from the server... (can take up to 10s if it was asleep)') }}</div>

    <div class="warn" *ngIf="serverOffline && !loadingSections">
      ⚠️ {{ tr(
        'সার্ভার থেকে সেটিং আনা যায়নি, তাই ডিফল্ট দেখাচ্ছে। ব্যাকএন্ডের নতুন আপডেট ডিপ্লয় হয়েছে কি না দেখুন, তারপর পেজ রিলোড করুন। (এই অবস্থায় সেভ করলে কাজ করবে না)',
        'Could not load settings from the server, showing defaults. Make sure the new backend is deployed, then reload. (Saving will not work until then)'
      ) }}
      <button type="button" class="btn ghost sm" (click)="loadSections()">↻ {{ tr('আবার চেষ্টা', 'Retry') }}</button>
    </div>

    <div class="sec" *ngFor="let s of sections; let i = index; trackBy: trackKey" [class.off]="!s.enabled">

      <div class="sec-top">

        <div class="sec-order">
          <button type="button" [disabled]="!canMoveUp(i)" (click)="move(i, -1)" title="Up">▲</button>
          <span>{{ i + 1 }}</span>
          <button type="button" [disabled]="!canMoveDown(i)" (click)="move(i, 1)" title="Down">▼</button>
        </div>

        <div class="sec-name">
          <strong>{{ metaOf(s.sectionKey).icon }} {{ nameOf(s) }}</strong>
          <small *ngIf="metaOf(s.sectionKey).pinnedTop">
            {{ tr('সবসময় সবার উপরে', 'Always on top') }}
          </small>
        </div>

        <label class="switch" [title]="s.enabled ? 'Visible' : 'Hidden'">
          <input type="checkbox" [(ngModel)]="s.enabled" (ngModelChange)="markDirty()">
          <span class="slider"></span>
        </label>
        <span class="vis">{{ s.enabled ? tr('দেখাচ্ছে', 'Visible') : tr('লুকানো', 'Hidden') }}</span>

      </div>

      <div class="sec-fields" *ngIf="metaOf(s.sectionKey).hasTitle || metaOf(s.sectionKey).limit !== 'none'">

        <label *ngIf="metaOf(s.sectionKey).hasTitle">
          {{ tr('টাইটেল (বাংলা)', 'Title (Bangla)') }}
          <input type="text" [(ngModel)]="s.titleBn" (ngModelChange)="markDirty()">
        </label>

        <label *ngIf="metaOf(s.sectionKey).hasTitle">
          {{ tr('টাইটেল (English)', 'Title (English)') }}
          <input type="text" [(ngModel)]="s.titleEn" (ngModelChange)="markDirty()">
        </label>

        <label *ngIf="metaOf(s.sectionKey).limit !== 'none'" class="narrow">
          {{ limitLabel(s) }}
          <input type="number" min="1" max="50" [(ngModel)]="s.itemLimit" (ngModelChange)="markDirty()">
        </label>

      </div>

      <!-- এই সেকশনের নিচের ব্যানার -->
      <div class="slot" *ngFor="let slot of slotsOf(s); trackBy: trackSlot">

        <div class="slot-head">
          <strong>🖼️ {{ slot.label }}</strong>
          <span class="count">
            {{ bannersIn(slot.key).length
              ? bannersIn(slot.key).length + ' ' + tr('টি ব্যানার', 'banner(s)')
              : tr('ব্যানার নেই — ফাঁকা থাকবে', 'No banner — stays blank') }}
          </span>
        </div>

        <div class="banner-list" *ngIf="bannersIn(slot.key).length">
          <div class="banner" *ngFor="let b of bannersIn(slot.key); trackBy: trackBanner">
            <img [src]="b.imageUrl" alt="banner" loading="lazy">
            <div class="banner-meta">
              <span *ngIf="b.linkUrl" class="link" [title]="b.linkUrl">→ {{ b.linkUrl }}</span>
              <button type="button" class="btn danger sm" (click)="deleteBanner(b)">
                🗑️ {{ tr('মুছুন', 'Delete') }}
              </button>
            </div>
          </div>
        </div>

        <div class="uploader">
          <input
            #fileInput
            type="file"
            accept="image/*"
            (change)="pickFile(slot.key, $event)">

          <input
            type="text"
            class="link-in"
            [(ngModel)]="upload(slot.key).linkUrl"
            placeholder="{{ tr('ক্লিক করলে যে লিংকে যাবে (ঐচ্ছিক) — /offers বা https://...', 'Link on click (optional) — /offers or https://...') }}">

          <button
            type="button"
            class="btn primary sm"
            [disabled]="!upload(slot.key).file || upload(slot.key).busy"
            (click)="addBanner(slot.key, fileInput)">
            {{ upload(slot.key).busy ? tr('আপলোড হচ্ছে...', 'Uploading...') : '⬆️ ' + tr('ব্যানার যোগ করুন', 'Add banner') }}
          </button>
        </div>

        <small class="tip">
          {{ tr('চওড়া ব্যানার ভালো (যেমন ১৪০০×২০০ px)। একই জায়গায় একাধিক দিলে ঘুরে ঘুরে দেখাবে।', 'Wide banner works best (e.g. 1400×200 px). Several banners in one place rotate.') }}
        </small>

      </div>

    </div>

  </section>


  <!-- =====================================================
       ২) পপুলার ক্যাটাগরি
  ====================================================== -->
  <section *ngIf="tab === 'categories'">

    <p class="hint">
      {{ tr(
        'হোমপেজের "জনপ্রিয় ক্যাটাগরি" বক্সগুলো এখান থেকে ঠিক হয়। নিচের বক্সে নাম লিখে খুঁজুন, তারপর "পপুলার করুন" চাপুন।',
        'The homepage "Popular Categories" boxes are controlled here. Search by name below, then click "Make popular".'
      ) }}
    </p>

    <div class="panel">

      <h3>➕ {{ tr('নতুন পপুলার ক্যাটাগরি যোগ করুন', 'Add a popular category') }}</h3>

      <input
        type="text"
        class="search"
        [(ngModel)]="search"
        (ngModelChange)="onSearchInput()"
        placeholder="{{ tr('🔍 ক্যাটাগরির নাম লিখুন (কমপক্ষে ২ অক্ষর, English বা বাংলা)', '🔍 Type a category name (min 2 letters, English or Bangla)') }}">

      <div class="loading" *ngIf="searching">{{ tr('খুঁজছি...', 'Searching...') }}</div>

      <div class="loading" *ngIf="searched && !searching && !results.length">
        {{ tr('কিছু পাওয়া যায়নি', 'Nothing found') }}
      </div>

      <div class="cat-grid" *ngIf="results.length">

        <div class="cat" *ngFor="let c of results; trackBy: trackId">

          <div class="cat-img">
            <img *ngIf="c.imageUrl" [src]="imageUrl(c.imageUrl)" alt="" loading="lazy" (error)="hideBroken($event)">
            <span *ngIf="!c.imageUrl">📂</span>
          </div>

          <div class="cat-info">
            <strong>{{ catName(c) }}</strong>
            <small *ngIf="c.parent?.name">{{ c.parent.name }}</small>
          </div>

          <button
            *ngIf="!c.popular"
            type="button"
            class="btn primary sm"
            [disabled]="popularBusyId === c.id"
            (click)="addPopular(c)">
            🔥 {{ tr('পপুলার করুন', 'Make popular') }}
          </button>

          <span *ngIf="c.popular" class="tag">✓ {{ tr('পপুলার', 'Popular') }}</span>

        </div>

      </div>

    </div>

    <div class="panel">

      <h3>🔥 {{ tr('এখন যেগুলো পপুলার', 'Currently popular') }} ({{ popular.length }})</h3>

      <div class="loading" *ngIf="loadingPopular">{{ tr('লোড হচ্ছে...', 'Loading...') }}</div>

      <div class="loading" *ngIf="!loadingPopular && !popular.length">
        {{ tr('এখনো কোনো ক্যাটাগরি পপুলার করা হয়নি', 'No popular categories yet') }}
      </div>

      <div class="cat-grid" *ngIf="popular.length">

        <div class="cat" *ngFor="let c of popular; trackBy: trackId">

          <div class="cat-img">
            <img *ngIf="c.imageUrl" [src]="imageUrl(c.imageUrl)" alt="" loading="lazy" (error)="hideBroken($event)">
            <span *ngIf="!c.imageUrl">📂</span>
          </div>

          <div class="cat-info">
            <strong>{{ catName(c) }}</strong>

            <div class="order-row">
              <label>{{ tr('ক্রম', 'Order') }}</label>
              <input type="number" min="0" [(ngModel)]="c.popularOrder">
              <button type="button" class="btn ghost sm" [disabled]="popularBusyId === c.id" (click)="savePopularOrder(c)">
                {{ tr('সেভ', 'Save') }}
              </button>
            </div>
          </div>

          <button type="button" class="btn danger sm" [disabled]="popularBusyId === c.id" (click)="removePopular(c)">
            ✕ {{ tr('সরান', 'Remove') }}
          </button>

        </div>

      </div>

    </div>

  </section>


  <!-- =====================================================
       ৩–৫) আগের অ্যাডমিন পেজগুলোই এখানে ঢোকানো
  ====================================================== -->
  <section *ngIf="tab === 'brands'" class="embed">
    <app-admin-popular-brands></app-admin-popular-brands>
  </section>

  <section *ngIf="tab === 'features'" class="embed">
    <app-admin-features></app-admin-features>
  </section>

  <section *ngIf="tab === 'shopmore'" class="embed">
    <app-admin-shop-more></app-admin-shop-more>
  </section>

</div>
